import React from "react";
import { PreviewLayout } from ".";
import { QRProps } from "@/contexts/QREditorContext/types";

export default function PreviewUrlStatic(props: QRProps<"url-static">) {
  const { qrUrlLink } = props.data || {};

  const conditionalPreviewRender = () => {
    if (props?.preview)
      return (
        <>
          <div className="browser-url qr-url">{qrUrlLink ? qrUrlLink : "www.mywebsite.com"}</div>
          <img
            src="https://res.cloudinary.com/dqemqumik/image/upload/f_auto,q_auto/v1693375245/assets/phone-url-empty_mpoief.png"
            alt="url"
            className="default-preview default-preview-url"
          />
        </>
      );
    else window.location.href = qrUrlLink;
  };

  return (
    <PreviewLayout
      page="url-static"
      dataQA="preview-url-static-container"
      includeBrowser>
      {conditionalPreviewRender()}
    </PreviewLayout>
  );
}
